<div siqGrid fx-direction="row" fx-layout-align="space-around center">
  <div siqGrid [fx-direction]="direction" fx-layout-align="center center" [class.mr-24]="!isColumn">
      <div siqGrid fx-layout-align="center center" [class.mb-8]="isColumn" class="radio-button cursor-pointer" (click)="selectOption(answer.id)">
          <div [class.active]="isButtonSelected(answer.id)"></div>
      </div>
      <span siqGrid fx-layout-align="center center" [class.ml-8]="!isColumn" [class]="textClasses">{{answer.text}}</span>
      <span siqGrid fx-layout-align="center center" class="siq-text-400 text-center fs-14 primary-200">{{answer.subtext ?? ''}}</span>
  </div>
</div>
